import { Appointment, Fitter, Score } from '../';

export interface FreeSlotsSubscriptionResult {
  appointments?: Appointment[];
  fitter?: Fitter;
  globalScores?: Score[];
}
